// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const landorus_therian: PokeData = {
  "id": 10021,
  "name": "landorus-therian",
  "height": 13,
  "weight": 680,
  "base_experience": 300,
  "types": [
    PokeType.GROUND,
    PokeType.FLYING
  ],
  "api_moves": [
    "swords-dance",
    "leer",
    "rock-throw",
    "earthquake",
    "fissure",
    "rock-slide",
    "outrage",
    "sandstorm",
    "imprison",
    "rock-tomb",
    "extrasensory",
    "sand-tomb",
    "block",
    "mud-shot",
    "hammer-arm",
    "punishment",
    "earth-power",
    "stone-edge",
    "smack-down",
    "bulldoze",
    "sandsear-storm"
  ],
  "moves": [
    "leer",
    "rock-throw",
    "earthquake",
    "fissure",
    "rock-slide",
    "outrage",
    "sandstorm",
    "rock-tomb",
    "mud-shot",
    "earth-power",
    "gust",
    "peck",
    "magnitude"
  ],
  "evolution_chain": {
    "id": 332,
    "item": null,
    "species": [
      {
        "name": "landorus",
        "order": 646,
        "types": [
          PokeType.GROUND,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 108,
    "speed": 113,
    "ability_power": 180
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
